import http from "../plugins/Axios";
import { userTypes } from "@/utils/constants";

export default {
  mutations: {},
  actions: {
    async getOrders(_, { offset = 1, limit = 10, type }) {
      let url = "orders/";

      if (type === userTypes["OZL"]) {
        url += "list-ozl";
      } else if (type === userTypes["OMTK"]) {
        url += "list-omtk";
      } else if (type === userTypes["DEPARTMENT"]) {
        url += "list-department";
      }

      try {
        const {
          data: { data, total },
        } = await http.get(url, {
          params: {
            offset: offset - 1,
            limit,
          },
        });
        return {
          total,
          data: data.map((item, index) => {
            item.index = index + 1;
            item.loading = false;
            item.show = false;
            item.children = [];
            return item;
          }),
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getOrderItems(_, params) {
      if (!params) params = {};
      let url = "orders/";
      if (params.type === userTypes["OZL"]) {
        url += "items-ozl";
      } else if (params.type === userTypes["OMTK"]) {
        url += "items-omtk";
      } else if (params.type === userTypes["DEPARTMENT"]) {
        url += "items-department";
      }
      try {
        const {
          data: { data },
        } = await http.get(url, {
          params: {
            objectId: params.id,
            ...params,
          },
        });
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async createOrder(_, order) {
      try {
        const {
          data: { data },
        } = await http.post("orders/add", order);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
